module.exports = __webpack_public_path__ + "static/bdxio-ed75bf97bc55566965ec6d2afec8e220.png";